module.exports = __webpack_public_path__ + "static/media/logo-banner-light.ef73ee6f.svg";